// Authored fallbacks until the matching Localise.biz keys are imported/downloaded.
export const campaignSignupCopy = {
  en: {
    'campaign-setup-title': 'Welcome to Lanla',
    'campaign-setup-description': 'Confirm your email and choose a personal password before cashout or your next sign-in.',
    'campaign-signup-error': 'We could not complete this step. Try again or request an account setup email.',
    'campaign-setup-email-sent': 'If this account needs setup, an email has been sent. Check your inbox.',
    'campaign-password-rule': 'Use 12–128 characters, including uppercase, lowercase, a number and a symbol. Both passwords must match.',
    'campaign-setup-complete-login': 'Your account is ready. Sign in with your new password to continue.',
    'campaign-switch-account': 'An account is already signed in. Switch accounts to continue this signup?',
    'campaign-switch-continue': 'Switch account and continue',
    'campaign-keep-account': 'Keep my current account',
    'campaign-new-password': 'New password',
    'campaign-confirm-password': 'Confirm password',
    'campaign-finish-setup': 'Finish account setup',
    'campaign-email': 'Email',
    'campaign-send-setup': 'Send account setup email',
    'campaign-normal-login': 'Go to sign in',
    'campaign-loading': 'Please wait',
    'campaign-retry': 'Try again',
    'campaign-temporary-access-title': 'Your account is created!',
    'campaign-temporary-access-description': "You're signed in temporarily for up to 24 hours. Check your email to confirm your address and create your password. You'll need it before your next sign-in or cashout.",
    'campaign-resend-setup': 'Resend setup email',
  },
  fr: {
    'campaign-setup-title': 'Bienvenue chez Lanla',
    'campaign-setup-description': 'Confirmez votre courriel et choisissez un mot de passe personnel avant un retrait ou votre prochaine connexion.',
    'campaign-signup-error': 'Cette étape n’a pas pu être complétée. Réessayez ou demandez un courriel pour finaliser votre compte.',
    'campaign-setup-email-sent': 'Si ce compte doit être finalisé, un courriel a été envoyé. Consultez votre boîte de réception.',
    'campaign-password-rule': 'Utilisez de 12 à 128 caractères, dont une majuscule, une minuscule, un chiffre et un symbole. Les deux mots de passe doivent être identiques.',
    'campaign-setup-complete-login': 'Votre compte est prêt. Connectez-vous avec votre nouveau mot de passe pour continuer.',
    'campaign-switch-account': 'Un compte est déjà connecté. Voulez-vous changer de compte pour poursuivre cette inscription?',
    'campaign-switch-continue': 'Changer de compte et continuer',
    'campaign-keep-account': 'Garder mon compte actuel',
    'campaign-new-password': 'Nouveau mot de passe',
    'campaign-confirm-password': 'Confirmer le mot de passe',
    'campaign-finish-setup': 'Finaliser mon compte',
    'campaign-email': 'Courriel',
    'campaign-send-setup': 'Recevoir le courriel pour finaliser mon compte',
    'campaign-normal-login': 'Aller à la connexion',
    'campaign-loading': 'Veuillez patienter',
    'campaign-retry': 'Réessayer',
    'campaign-temporary-access-title': 'Votre compte est créé!',
    'campaign-temporary-access-description': 'Votre accès est temporaire pour une durée maximale de 24 heures. Consultez votre courriel pour confirmer votre adresse et créer votre mot de passe. Vous en aurez besoin avant votre prochaine connexion ou un retrait.',
    'campaign-resend-setup': 'Renvoyer le courriel de finalisation',
  },
};
